import { Html } from "@react-three/drei"
import classNames from "classnames"
import { useContext, useState } from "react"

import AppContext from "../../hooks/AppConext"
import data from "./data.json"

const Annotation = ({ position, label, icon, reverse = false }) => {
  const [active, setActive] = useState(false)
  return (
    <Html position={position} className="html">
      <div
        className={classNames("annotation", {
          reverse,
          active,
        })}
        onClick={(e) => {
          e.stopPropagation()
          setActive(!active)
        }}
      >
        {icon && (
          <div className="icon-container">
            <img alt="" src={`/icons/${icon}.svg`} />
          </div>
        )}
        {active && <span>{label}</span>}
      </div>
    </Html>
  )
}

export const Annotations = () => {
  const { selected } = useContext(AppContext)
  return (
    data[selected] && (
      <group rotation-y={-0.02}>
        {Object.entries(data[selected]).map(([name, props], i) => (
          <Annotation key={i} name={name} {...props} />
        ))}
      </group>
    )
  )
}
